import { useQuery } from "@tanstack/react-query";
import { getExpensesReportsSummary } from "../services";
import type {
	ExpenseReportPeriod,
	ExpensesReportsSummaryResponse,
} from "../types";

const initialData: ExpensesReportsSummaryResponse = {
	filter: {
		startDate: "",
		endDate: "",
		days: 0,
		selectedVehiclesCount: 0,
	},
	totals: {
		expensesTotalAmount: 0,
		expensesTotalCount: 0,
	},
	typeCards: [],
	monthlyEvolution: [],
	distributionByCategory: [],
};

export function useGetExpensesReports(payload: ExpenseReportPeriod) {
	return useQuery<ExpensesReportsSummaryResponse>({
		queryKey: ["expenses", "reports", payload],
		queryFn: () => getExpensesReportsSummary(payload),
		initialData,
		enabled: !!payload.startDate && !!payload.endDate,
	});
}
